import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom'
import Aboutuslearners from '../Landing/Subcomponent/aboutuslearners';
import Aluminicompany from '../Landing/Subcomponent/aluminicompany';
import Whyedu from '../Landing/Subcomponent/whyedu';


class Certificateinspark extends Component {
    render() {
        return (
            <div>
                  <div aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><Link ><FontAwesomeIcon icon={faHome} />  &nbsp; HOME</Link></li>
                    <li class="breadcrumb-item active" aria-current="page">Certificate course in Spark</li>
                </ol>
            </div>
         <section class="course-header bg-yellow11" id="course-header">
            <div class="row">
               <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5  six-sigma-bkg">
                  <h1>Certificate course in<br /> Spark<br /></h1><br /><br />
                  <p>Accelerate your Career. Stay Ahead of the Curve </p>
                  <br /><br />
                  <div class="form-group">
                     <a href="#apply-now" class="btn btn-md enroll-btn">Enroll Now </a>
                   
                    <button type="button" class="btn btn-md download-bro-btn" data-toggle="modal" id="myBtn"
                        data-target="#myModal"  onclick="return gtag_report_conversion('<?php echo $baseurl;?>course/certificate-course-in-spark');">Download
                     brochure</button><br /><br />
                   
                  </div>
               </div>
               <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-2"></div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-5">
                <p>Jointly Delivered by eduplusnow and Industry Expert </p>
                  <br />
                  <table class="table-highlight">
                     <tr>
                        <td> <img alt="executive2" width="" src="/assets/images/epn.svg" /></td>
                     </tr>
                  </table>
                  <br />
               </div>
            </div>
            <div class="br-hide-mobile"> <br /> <br /> </div>
         </section>
         <div class="course-main-contains def-z">
                <div class="card" id="Description">
                    <div class="row contanint-display">
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp;WEEKDAY BATCH</b>  
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4">    
                        <b><i class="fa fa-calendar" ></i>&nbsp;&nbsp;30 hours<br />
                        <i class="fa fa-tasks" ></i> &nbsp;&nbsp; WEEKEND BATCH</b>
                        </div>
                        <div class="col-lg-4 col-xl-4 col-12 col-sm-12 col-md-4" id="Description">    
                        
                        </div>
                    </div>
                </div>
            </div>
            <section class="def-z">
            <div class="header" id="myHeader">
                    <ul>
                        <li><a href="#Description">Description</a></li>
                        <li><a href="#Trends">Industry Trends</a></li>
                        <li><a href="#tools">Tools</a></li>
                        <li><a href="#syllabus">Syllabus</a></li>               
                        <li><a href="#Outcomes">Learning Outcomes</a></li>           
                        <li><a href="#Review">Learner Review</a></li>          
                        <li class="btn-header cs-dx"><a href="#apply-now">Enroll Now</a></li>           
                    </ul>
            </div>
            </section>

         <br />
         <br />
         <section class="course-description" id="course-description">
            <div class="row">
               <div class="col-sm-12">
                  <h3>Description</h3>
                  <p align = "justify" class="Descriptionbold">The Spark is created & delivered by edu plus now along with industry experts.</p>
                  <p align = "justify" >Apache Spark is open source framework including Spark streaming, Spark SQL and graph processing.</p>
               </div>
             
            </div>
            <br/>
            <div class="row">
               <div class="col-sm-12">
                  <h3>Course Features</h3>
                  <ul class="highlight-ul" >
                     <li>Eduplusnow's Spark training will teach you basics of spark, spark sql, spark streaming to prepare you as professional in Spark.</li>
                  </ul>
               </div>
              
            </div>
           
            <br />
            <div class="row">
            <div class="col-sm-6">
               <h5 id="Trends"> Who Should Enroll? </h5>
               <ul class="admission-ul">
                  <li>Ideal for professionals aspiring for a career in the field of real time big data analytics, analytics professionals, IT developers, testers and students who want to gain a through knowledge of Spark.</li>
               </ul>
            </div>
            <div class="col-sm-6">
               <h5> Eligibility </h5>
               <ul class="admission-ul">
                  <li>No Pre requisities for Spark training , prior  knowledge of any programming language and basic understanding of any database, SQL. Knowledge of Linux is also benificial but not mandatory.</li>
               </ul>
            </div>
         </div>
         </section>

         <section class="course-industry-trends bg-secondary" id="course-industry-trends">
            <div class="row">
               <div class=" col-md-6 col-sm-12">
                  <h3> Industry Trends </h3>
                  <br />
                  <h5>Job Roles</h5>
                  <ul class="industry-trends-ul">
                     <li>Software Engineer</li>
                     <li id="tools">Spark Developer</li>
                     <li>Software Develoer</li>
                  </ul>
               </div>
               <div class="col-md-6 col-sm-12">
                  <img alt="datascience11"src="/assets/images/icons/industry-trends.svg" />
               </div>
            </div>
         </section>
         
         <br /> 
         <section class="course-tools-covered" >
            <h3> Tools Covered </h3>
            <br />
            <div class="row">
               <div class="col-md-3 col-sm-12">
                  <div class="card cards-single" id="syllabus">
                     <center><img  src="/assets/images/icons/apachesparklogo.png" alt="" /> </center>
                  </div>
               </div>
            </div>
         </section>
      
         <section class="course-syllabus" id="course-syllabus">
         <div class="row" >
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-10">
                  <br />
                  <div class="syl-bg">
                  <h3> Syllabus </h3>
                  <div id="de_syllabus">
                     <div class="panel-group">
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus">
                                     </i>  Introduction to Spark 
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i> Spark Architecture 
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i> Pyspark Introduction
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus"></i>
                                 Data Frame opertation in Pyspark
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>
                                 Spark RDD Concepts,Fundamentals,RDD Creations,RDD Operations
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus">
                                     </i>Common transformations and  actions in RDD
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus"></i>
                                Hands on Spark SQL exercise
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus"></i>
                                DataBricks Community Edition for Spark
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus"></i>Streaming concepts
                              </h6>
                           </div>
                        </div>

                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                <i class="indicator fa fa-plus"></i>
                                Initializing streaming context
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>Introduction to MLIB
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>MLIB operations
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>Exercice for MLIB
                              </h6>
                           </div>
                        </div>
                        <div class="panel panel-info" id="Outcomes">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>
                                 Introduction to Recommendation Engine in Spark
                              </h6>
                           </div>
                        </div> 
                        <div class="panel panel-info">
                           <div class="panel-heading" id="de_heading1" data-toggle="collapse"
                              href="#de_syllabus1" aria-expanded="true" aria-controls="de_syllabus1">
                              <h6 class="panel-title">
                                 <i class="indicator fa fa-plus"></i>usecase in Recommendation Engine in Spark
                              </h6>
                           </div>
                        </div> 
                     </div>
                  </div>
                  </div>
                  </div>
                  </div>
                
         </section>
        
         <section class="course-learning-outcome bg-secondary " id="course-learning-outcome">
         <div class="row">
         <div class="col-sm-6">
         <h3>Learning Outcomes</h3>
         <ul class="lo-ul">
         <li>By attending Spark training at eduplusnow you will have essential skills of spark , Spark streaming, Spark SQL .
         </li>
         </ul>
         <br />
         <h5>Assessment </h5>
         <p align="justify" id="Review">
         Periodic assessment and case studies evaluations by edu plus now have been built in throughout the duration of the course.
         </p>
         </div>
         <div class="col-sm-6">
         <img alt="datascience18" src="/assets/images/icons/certificate1.png" />
         <p class="img-below-text text-center">Awarded by edu plus now 
         </p>
         </div>
         </div>
         </section>
         <section class="course-admission-process" id="course-admission-process1">
         <br />	 
    
         </section>
         <Aboutuslearners />
          <Aluminicompany />
         <section class="courses-feesm">
            <section class="course-fees" id="course-fees">
            <div class="row box-sh" >
                   <div class="col-sm-12 col-lg-12	col-xl-5  pd-fee" >
       
                      </div>
                    <div class="vertical-line-fee"> </div>
                    <div class="col-sm-12 col-lg-12 col-xl-6 pd-fee">
                        <div class="row">
                            <div class="col-sm-10"> <br /><br />
                                <h5>Features</h5>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12 col-sm-12">
                            Eduplusnow's Spark Training Course Will Master you in
                              <ul class="highlight-ss" >
                              <li>Spark Architecture.</li>
                              <li>Spark RDD Concepts,Fundamentals,RDD Creations,RDD Operations.</li>
                              <li>Data Frame opertation in Pyspark.</li>
                              <li>Spark Streaming concepts.</li>
                              <li>Recommendation Engine in Spark.</li>
                              </ul>
                            </div>
                            <p>{// eslint-disable-next-line
                             }<marquee onmouseover="this.stop();" onmouseout="this.start();" class="marquee-enroll" >"If a group of four or more participants enroll with us, a concession of 10% will be awarded to each one of them. For more details Contact us."<a href="tel://8956167195 "> &nbsp;&nbsp;<i class="fa fa-mobile" aria-hidden="true"></i> +91 8956167195</a></marquee>
                           </p>   
                            <p align = "justify" class="font-text-alumni" >
                                <span>*</span>Alumni of Eduplusnow, VIT, VIIT, VU Will Get Special Discount, To Grab your Discount coupon Please Contact  &nbsp; <a href="tel://8956167195" class="contact-us-mobile"> <i class="fa fa-phone icon-tick"> </i>+918956167195. </a><br /></p>

                        </div> 
                        </div>
                </div>
             </section> 
             </section> 
       
             <Whyedu />

         <section class="course-about-instructor bg-secondary " id="course-about-instructor">
            <div class="row">
            <div class="col-sm-12">
            <h3>
            About the Organization
            </h3>
            <br />
            <img alt="datascience23" width="200px" src="/assets/images/eduplusnow.png" />
            <br /><br />
            <p align="justify">edu plus now is an online educational platform that was launched in 2019 to bridge the skill gap between classroom learning, real business challenges and to help students achieve their career potential.
            </p>
            <br />
            <p align="justify">Aimed at providing learners with essential technical skills, edu plus now courses are created to be the perfect amalgamation of inputs from industry experts and highly-qualified professors from the country’s top educational institutions. This allows individuals and companies to close the skill gap quickly, innovate faster and achieve their key objectives. At edu plus now, we believe in preparing students for success in a changing world by providing online courses that pave the path for a successful career. Built under the aegis of the Vishwakarma Group, the online education platform provides flexible learning that fits a learner’s schedule. 
            </p>
            </div>
            </div>
            </section>
       
             <section>
               <div class="row">
               
               </div>
            </section>
            <div class="modal fade bd-example-modal-sm" id="myModal" role="dialog" >
                 <div class="modal-dialog modal-md">
  
                        <div class="modal-content">
                            <div class="modal-header" >
                            <span class="close" id="close_form"
                                data-dismiss="modal">&times;</span>
                            <br />
                            </div>
                            <div class="modal-body" >
                                <div class="panel panel-default paper-shadow box_detail">
                                        <h5 class="text-center "> Download The Course Brochure </h5>
                                    <form method="post" class="form-row"  onsubmit="return validate()">
                                        <b>Your Name</b><input class="form-control" pattern="[A-Za-z ]{1,32}" type="text"
                                            required="" autocomplete="on" name="name" id="name" />
                                        <b>Your email</b><input class="form-control" type="email" required=""
                                            autocomplete="on" name="emaill" id="emaill" />
                                        <b>Your Contact No</b><input class="form-control" pattern="[7-9]{1}[0-9]{9}"
                                            type="tel" required="" autocomplete="on" name="contactt" id="contactt" />
                                        <input type="hidden" name="id" id="exd-course-name" value='<?php echo $words[0]; ?>' />
                                        <input type="hidden" id="backurl" value="<?php echo $backurl?>" />
                                        <br />
                                        <div>
                                        <div class="form-group">
                                            <div id="recaptcha" class="g-recaptcha"
                                                data-sitekey="6Lejh30UAAAAAPhZirvpXtobtIE80K7NUzsDqKjE"></div>
                                            <div id="captcha"></div>
                                        </div>
                                    </div>
                                    <div class="mob_cb" >
                                         <div>
                                         </div>
                                        <br />
                                        <button class="btn_1 rounded" type="button" onclick="getbroucher(<?php echo '\''.$filepath.'\'';?>)"  id="exd-download" ><i class="icon-download"></i> Brochure</button>
                                    </div>
                                    <br />
                                    </form>
                                </div>
                           </div>
                        </div>
                 </div>
             </div>
            </div>
        );
    }
}

export default Certificateinspark;
